import { render, staticRenderFns } from "./GymCarousel.vue?vue&type=template&id=a057ac66&scoped=true"
import script from "./GymCarousel.vue?vue&type=script&lang=js"
export * from "./GymCarousel.vue?vue&type=script&lang=js"
import style0 from "./GymCarousel.vue?vue&type=style&index=0&id=a057ac66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a057ac66",
  null
  
)

export default component.exports